import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import iconClose from "../../../../assets/img/close-homepage.svg";
import dropdownIcon from "../../../../assets/img/dropdown-homepage.svg";
import logo from "../../../../assets/img/posLogo.svg";
import globalIcon from "../../../../assets/img/globalIcon.svg";
import { homePageNavItems } from "../../../../helpers/constants";
import { useHistory } from "react-router-dom";
import { i18n } from "../../private/languageSelector";

function MenuModal({ show, onHide, setShowContactModal, goToPricing }) {
  const [showCategories, setShowCategories] = useState(false);
  const history = useHistory();

  const handleShowCategories = (id) => {
    if (id === "1") {
      setShowCategories(!showCategories);
    }
    if (id === "4") {
      setShowContactModal(true);
      onHide();
    }
    if (id === "3") {
      history.push("/help");
      onHide();
    }
  };
  const selectedLanguage = localStorage.getItem("language");

  const handleChangeLanguage = () => {
    let language = selectedLanguage === "english" ? "arabic" : "english";
    localStorage.setItem("language", language);
    window.location.reload();
  };

  const translateLabels = (label) => {
    return label === "Log in"
      ? i18n("HomePage.LogIn")
      : label === "Industries"
      ? i18n("HomePage.Industries")
      : label === "Prices"
      ? i18n("HomePage.Prices")
      : label === "Contact"
      ? i18n("HomePage.Contact")
      : label === "Help"
      ? i18n("HomePage.Help")
      : label;
  };
  return (
    <div>
      <Modal
        className={`modal-drawer invoice-drawer full-height-dialog full-width-dialog ${
          selectedLanguage === "arabic" ? "modal ar" : "modal-dialog-arabic"
        }  `}
        size="lg"
        aria-labelledby="example-modal-sizes-title-lg"
        show={show}
        onHide={onHide}
      >
        <Modal.Header
          style={{
            background: "transparent",
            textAlign: "start",
            border: "none",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            flexDirection: selectedLanguage === "arabic" ? "row-reverse" : "row",
          }}
          className="mt-3"
        >
          <span onClick={onHide} className="cursor-pointer">
            <img src={iconClose} alt="iconClose" width={19} height={18} />
          </span>
          <span>
            {" "}
            <img
              className="home-logo cursor-pointer"
              onClick={() => {
                history.push("/homePage");
              }}
              width={"113px"}
              height={25}
              src={logo}
              alt="logo"
            />
          </span>
          <span className="start-btn">
            <button
              style={{
                borderRadius: "5px",
                border: "0",
                backgroundColor: "#9B51E0",
                color: "#FFFFFF",
                padding: "5px 10px",
                fontWeight: "700",
                fontSize: "14px",
                maxHeight: "29px",
                height: "auto",
              }}
              onClick={() => history.push("/auth/registration")}
            >
              {i18n("HomePage.TryNow")}
            </button>
          </span>
        </Modal.Header>
        <Modal.Body className="overlay overlay-block cursor-default" style={{ marginTop: "-1rem" }}>
          <div className="mt-3">
            <ul className="p-0 m-0">
              {homePageNavItems?.map((item, index) => {
                return (
                  <li
                    style={{
                      listStyle: "none",
                      borderBottom: "1px solid #E0E0E0",
                      color: "#4F4F4F",
                      fontSize: 16,
                      fontWeight: item?.label === "Log in" ? 700 : 500,
                      paddingTop: "2rem",
                      paddingBottom: "2rem",
                      textAlign: selectedLanguage === "arabic" ? "right" : "left",
                    }}
                    key={index}
                  >
                    {item?.label !== "language" ? (
                      <>
                        <div
                          className={`d-flex justify-content-between align-items-center ${
                            selectedLanguage === "arabic" ? "flex-row-reverse" : "flex-row"
                          }
                          cursor-pointer
                          `}
                          onClick={() => {
                            handleShowCategories(item?.id);
                          }}
                        >
                          <span
                            className={`${item?.label === "Log in" ? "mx-auto" : "mx-0"} `}
                            onClick={() => {
                              item?.label === "Log in" && history.push("/auth/login");
                              item?.label === "Prices" && goToPricing();
                            }}
                          >
                            {translateLabels(item?.label)}
                          </span>
                          {item?.content ? (
                            <>
                              <img src={dropdownIcon} alt="dropdown" />
                            </>
                          ) : null}
                        </div>
                        {showCategories && item?.content && item?.id === "1" && (
                          <div className="mt-4">
                            {item?.content?.map((category) => {
                              return (
                                <div className="py-2" style={{ color: "#4F4F4F", fontSize: "14px", fontWeight: 400 }}>
                                  {selectedLanguage === "arabic" ? category?.arabicLabel : category?.label}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div
                          className={`d-flex  align-items-center ${selectedLanguage === "arabic" ? "justify-content-end" : "justify-content-start"} `}
                          onClick={handleChangeLanguage}
                        >
                          <img src={globalIcon} alt="language" />
                          <span className="ml-2"> {selectedLanguage === "english" ? "العربية" : "English"}</span>
                        </div>
                      </>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default MenuModal;
